import { type PayloadAction, createSlice, nanoid } from '@reduxjs/toolkit'

export type SelectedCameraControlType = {
  option: 'cursor' | 'rotate'
  cameraAlignmentKey: string
  previousCameraAlignmentKey?: string
}

const initialState: SelectedCameraControlType = {
  option: 'cursor',
  cameraAlignmentKey: '',
}

export const selectedCameraControlSlice = createSlice({
  name: 'selected-camera-control-type',
  initialState,
  reducers: {
    setSelectedCameraControlType: (state, action: PayloadAction<'cursor' | 'rotate'>) => {
      state.option = action.payload
    },
    resetCamera: (state) => {
      // This key is used to force the camera to fit the bounds
      // It should re-center every time this changes
      state.cameraAlignmentKey = nanoid()
    },
    setPreviousCameraAlignmentKey: (state, action: PayloadAction<string>) => {
      state.previousCameraAlignmentKey = action.payload
    },
  },
})

export const { setSelectedCameraControlType, resetCamera, setPreviousCameraAlignmentKey } = selectedCameraControlSlice.actions

export default selectedCameraControlSlice.reducer
